import { ArrowPathIcon, PaintBrushIcon } from "@";
import type { TableActionsProps } from "../types";
import { useCanShow } from "@/shared/hooks";
import { Tooltip } from "@/shared/components";
import React from "react";

export const TableActions = ({
  row,
  reSend,
  orderItemId,
  isResendOrder,
  isSmsBalanceLow,
  reDesignAttribute,
}: TableActionsProps) => {
  if (!useCanShow("editGiftProject")) return null;

  const renderTooltip = (id: string | number, title: string) => (
    <Tooltip title={title} id={id} className={undefined} hint={undefined} />
  );

  const renderIcon = (
    id: string,
    IconComponent: React.ComponentType<{ className?: string }>,
    onClick: () => void,
    title: string,
  ) => (
    <>
      <span
        data-tooltip-target={id}
        data-tooltip-placement="right"
        className="icon-style"
        onClick={onClick}
      >
        <IconComponent className="w-5" />
      </span>
      {renderTooltip(id, title)}
    </>
  );

  return (
    <div className="flex items-center gap-2">
      <button
        disabled={
          (isResendOrder && orderItemId === row.orderItemId) || isSmsBalanceLow
        }
        onClick={() => reSend(row.orderItemId)}
        className="icon-style"
        data-tooltip-target={String(row.orderItemId)}
        data-tooltip-placement="right"
      >
        <ArrowPathIcon
          className={`w-5 ${isResendOrder && orderItemId === row.orderItemId ? "animate-spin" : ""}`}
        />
      </button>
      {renderTooltip(row.orderItemId, "إعادة الارسال")}

      {renderIcon(
        `redesign-tooltip-${row.orderId}`,
        PaintBrushIcon,
        () => reDesignAttribute(row),
        "اعادة تصميم",
      )}
    </div>
  );
};

export default TableActions;
